export const setAuth = auth => ({
  type: "SET_AUTH",
  auth
});

export const setExpiresIn = expiresIn => ({
  type: "SET_EXPIRES_IN",
  expiresIn
});

export const setTokenCreatedAt = createdAt => ({
  type: "SET_TOKEN_CREATED_AT",
  createdAt
});

export const setAuthUser = user => ({
  type: "SET_AUTH_USER",
  user
});

export const fetchAuthUser = user => ({
  type: "FETCH_AUTH_USER",
  payload: user
});

export const setAuthToken = token => ({
  type: "SET_AUTH_TOKEN",
  token
});

export const setAuthLoggedAs = loggedAs => ({
  type: "SET_AUTH_LOGGED_AS",
  loggedAs
});

export const setAuthLoggedAsPost = loggedAsPost => ({
  type: "SET_AUTH_LOGGED_AS_POST",
  loggedAsPost
});

export const setCurrentOrganization = organization => ({
  type: "SET_CURRENT_ORGANIZATION",
  payload: organization
});

export const setSwitchSpace = typeUser => ({
  type: "SET_SWITCH_SPACE",
  typeUser
});

export const setWithOutHeader = withoutHeader => ({
  type: "SET_WITH_OUT_HEADER",
  withoutHeader
});

export const setWithoutMenu = withoutMenu => ({
  type: "SET_WITHOUT_MENU",
  withoutMenu
});

export const setPartnerOptions = partners => ({
  type: "SET_PARTNER_OPTIONS",
  partners
});

export const setPartner = partner => ({
  type: "SET_PARTNER",
  partner
});

export const setPartnerZone = zone => ({
  type: "SET_PARTNER_ZONE",
  zone
});



// WEBPACK FOOTER //
// ./src/actions/actions/auth.js